<template>
  <div>
    <a-select
    v-model="selectTenant"
    show-search
    placeholder="请选择服务商"
    class="severs_select"
    :disabled="disabled"
    dropdown-class-name="dropdown"
    :dropdown-match-select-width="false"
    :filter-option="false"
    :not-found-content="null"
    @search="handleSearch"
    @change="handleChange"
  >
    <a-select-option v-for="item in TenantList" :key="item.id">
      <!-- <div> {{item.customerName}}</div> -->
        {{ item.ownerTenantName }}<span class="customer_style">({{item.customerName}})</span>
    </a-select-option>
  </a-select>
  </div>
</template>

<script>
import {getSignType} from '@/api/enterprise/authentication'
// import {setEnterprise} from '@/utils/auth'
import { mapMutations } from 'vuex'

  export default {
  name:'ServiceSelect',
  props:{
    isDefaultSelect:{
      type:Boolean,
      default:()=>(false)
    },
    value:{
      type:String,
      default:()=>''
    },
    isQueryAll: {
      type: Boolean,
      default: false
    },
    onlySelect:{
      type:Boolean,
      default:()=>(true)
    },
    disabled:{
      type:Boolean,
      default:()=>(false)
    }
  },
    data(){
      return {
        TenantList:[],
        selectTenant:undefined
      }
    },
    created(){
      this.fetchData()
    },
    methods:{
      ...mapMutations('user', ['SET_USER_DATA']),
      handleReset(){
        this.selectTenant=undefined
      },
    async fetchData(value){
        const {customers} =this.$store.state.user
        let data={}
        if (this.isQueryAll) {
          const customerCodes = customers.map(item=>item.customerCode)
          data = {
            customerCodes,
            isQueryAll: true,
          }
        } else {
          const params=customers.map(item=>item.customerId)
          data = {
            ids:params,
            ownerTenantNameLike:value,
          }
        }
        const res= await getSignType(data)
        this.TenantList=res
        if((res.length===1&&this.onlySelect)||this.isDefaultSelect){
          if(this.value){
            this.selectTenant=this.value
          }else{
            this.selectTenant=res[0]?.id
          }
          this.handleChange(this.selectTenant)
        }
      },
      handleSearch(value) {
        this.fetchData(value)
      },
      handleChange(value) {
        const [select = {}]= this.TenantList.filter(item=>item.id===value) || []
         const {carrierTenantId,carrierTenantName,id,customerCode,customerName}=select
         const {customers}=this.$store.state.user
        const accountData={
          id:customers.filter(item=>item.customerId===id)[0]?.orgId,
          identityId:customerCode
        }
        localStorage.setItem('accountData',JSON.stringify(accountData))
         const selectCarriering={
            tenantId:carrierTenantId,
            tenantName:carrierTenantName,
            customerId:id,
            customerCode,
            customerName,
         }
         Object.keys(selectCarriering).forEach(item=>{
            this.SET_USER_DATA([item,selectCarriering[item]])
         })
        this.$emit('change',select)
     },
  }
    
  }
</script>

<style lang="less" scoped>
.customer_style {
  font-size: 14px;
  margin-left: 10px;
  color: #ccc;
}
.dropdown {
width: 500px;
}
</style>